// extracted by mini-css-extract-plugin
export var contentWrapper = "EventHighlightLeftImage-module--contentWrapper--d2a62";
export var image = "EventHighlightLeftImage-module--image--34371";
export var imageWrapper = "EventHighlightLeftImage-module--imageWrapper--a9217";
export var mediaWrapper = "EventHighlightLeftImage-module--mediaWrapper--22e53";
export var wrapper = "EventHighlightLeftImage-module--wrapper--a3bc0";